import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { MercerDialogType } from '../../../enums/mercer-dialog-type.enum';
import { MercerEvaluationMember } from '../../../models/mercer-support-evaluation-member.model';

@Component({
  selector: 'coin-c-position-comparisation-filter-list',
  templateUrl: './position-comparisation-filter-list.component.html',
  styleUrls: ['./position-comparisation-filter-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PositionComparisationFilterListComponent {
  @Input() isLocked: boolean;
  @Input() isReadOnly: boolean;
  @Input() lazyLoadFn: (key: string) => (search: string) => Observable<string[]>;
  @Input() public dialogType: MercerDialogType;
  @Input() public relatedPositions: MercerEvaluationMember[];
  @Input() public selectedOrgLevel: string;
  @Input() public selectedOrgCode: string;

  @Output() public updateRelatedPositions = new EventEmitter<void>();
  @Output() public openPosition = new EventEmitter<MercerEvaluationMember>();
}
